/* istanbul ignore file */
import { isSuperAdmin } from '@lumapps/permissions';
import { connect } from '@lumapps/redux/react';

import { DigitalAssistantSideNavigation } from './DigitalAssistantSideNavigation';

const mapStateToProps = (state: BackOfficeStore) => {
    const isAllowed = isSuperAdmin(state);

    return {
        isAllowed,
    };
};

const ConnectedDigitalAssistantSideNavigation = connect(mapStateToProps)(DigitalAssistantSideNavigation);

export { ConnectedDigitalAssistantSideNavigation as DigitalAssistantSideNavigation };
